import Firebase from 'firebase'

import constants from '@/constants'

const app = Firebase.initializeApp({
  apiKey: constants.FIREBASEAPIKEY,
  appId: constants.FIREBASEAPPID,
  messagingSenderId: constants.FIREBASEMESSAGINGSENDERID,
  projectId: constants.FIREBASEPROJECTID
})

export default app

export function firebaseMessagingIsSupported () {
  return Firebase.messaging.isSupported()
}
